export default "__VITE_ASSET__f9bZC4gx__"